import TabController from './TabController';

export default TabController;
